import type { IPostTrainingAppliesCandidateResponseItem } from "@api";
import CloseIcon from "@mui/icons-material/Close";
import { Button, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { Dialog, LoadingBackdrop } from "@styleguide";
import type { FormEvent } from "react";
import type { DefaultValues } from "react-hook-form";
import { ModalTrainingApplyForm } from "./form";
import { useModalTrainingApply } from "./logics";
import type { IModalTrainingApplyForm } from "./types";

export interface IModalTrainingApplyDisabledFields {
  status?: boolean;
}

export interface IModalTrainingApplyProps {
  open: boolean;
  defaultValues?: DefaultValues<IModalTrainingApplyForm>;
  disabledFields?: IModalTrainingApplyDisabledFields;
  onClose: () => void;
  onCreate?: (createdTrainingApply: IPostTrainingAppliesCandidateResponseItem) => void;
}

export const ModalTrainingApply = ({
  open,
  defaultValues,
  disabledFields,
  onClose,
  onCreate,
}: IModalTrainingApplyProps) => {
  const { hookForm, formRef, handleSubmit, loading, documentsProgress } = useModalTrainingApply(
    open,
    defaultValues,
    onClose,
    onCreate
  );

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    await handleSubmit(event);
    event.preventDefault();
  };

  return (
    <Dialog open={open} disableEnforceFocus>
      <DialogTitle component={Stack} direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Nouvelle formation suivie</Typography>
        <IconButton onClick={onClose} sx={{ mr: "-10px" }} disabled={loading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <ModalTrainingApplyForm
          disabledFields={disabledFields}
          formRef={formRef}
          hookForm={hookForm}
          onSubmit={onSubmit}
          loading={loading}
          documentsProgress={documentsProgress}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onClose} disabled={loading}>
          Annuler
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          loading={loading}
          onClick={() => formRef.current?.requestSubmit()}
        >
          Créer
        </Button>
      </DialogActions>
      <LoadingBackdrop loading={loading} />
    </Dialog>
  );
};
